import { Component, inject, OnInit, OnDestroy, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ErrorModalComponent } from '@shared/components/error-modal.component/error-modal.component';
import { AuthenticationService } from '@core/services/authentication/authentication.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ErrorModalComponent],
  templateUrl: './app.html',
  styleUrls: ['./app.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  protected readonly title = signal('frontend-planes-complementarios-afp-popular');

  private authService = inject(AuthenticationService);
  private onPageShow = (event: PageTransitionEvent) => {
    if (event.persisted && !this.authService.isAuthenticated) {
      window.location.replace('/');
    }
  };

  ngOnInit(): void {
    window.addEventListener('pageshow', this.onPageShow);
  }

  ngOnDestroy(): void {
    window.removeEventListener('pageshow', this.onPageShow);
  }
}
